import { render } from "./headerComponent_mjstore-customer_list_with_customer_type.vue?vue&type=template&id=17a9e08c"
import script from "./headerComponent_mjstore-customer_list_with_customer_type.vue?vue&type=script&lang=ts"
export * from "./headerComponent_mjstore-customer_list_with_customer_type.vue?vue&type=script&lang=ts"
script.render = render

export default script